"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElasticsearchSortForSortParams = void 0;
function getElasticsearchSortForSortParams(sortParams) {
    return sortParams.map(sortParam => {
        const temp = {};
        temp[sortParam.field] = {
            order: sortParam.order
        };
        return temp;
    });
}
exports.getElasticsearchSortForSortParams = getElasticsearchSortForSortParams;
//# sourceMappingURL=getElasticsearchSortForSortParams.js.map